<div class="container">
  <h1 class="text-center">Report Card List</h1>
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label >Select Student</mat-label>
      <mat-select [(ngModel)]="selectStudent">
        <mat-option *ngFor="let student of uniqueStudents" [value]="student">{{student}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-2">
      <mat-label>Select Teacher</mat-label>
      <mat-select [(ngModel)]="selectedTeacher">
        <mat-option *ngFor="let teacher of uniqueTeachers" [value]="teacher">{{teacher}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-2">
      <mat-label>Select Centre</mat-label>
      <mat-select (selectionChange)="setSelectedCentreCode($event)" [(ngModel)]="selectedCentreCode">
        <mat-option *ngFor=" let c of (centres$|async) " [value]="c.centreCode">{{c.centreName}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="justify-content-start gap-2 d-flex col-md-2">
      <button mat-mini-fab (click)="searchData()"><mat-icon>search</mat-icon></button>
      <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>
    </div>
  </div>

<div class="card p-2">
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
                  <h2>Report Card Table</h2>
      </li>
      <li class="dropdown m-l-20">
        <label><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field" permission="Report Card" [permissionTypes]="[PermissionType.ADD]"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
    <ul class="header-buttons mr-2">
            <li class="me-2">
              <button  *ngIf="!isExternal"  mat-mini-fab color="primary" routerLink="/home/reports/report-card" permission="Report Card" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]" >
                <mat-icon class="col-white" >add</mat-icon>
              </button>
            </li>

      <li>
        <button
          mat-mini-fab color="accent"
          (click)="downloadExcel()">
          <mat-icon>download</mat-icon>
        </button>
      </li>
    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" matSort >
        <!-- Position Column -->
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let element;let i =index"> {{i+1}} </td>
        </ng-container>

       <ng-container matColumnDef="center">
         <th mat-header-cell *matHeaderCellDef> Centre Name </th>
         <td mat-cell *matCellDef="let element"> {{element.centreName }} </td>
        </ng-container>
        <ng-container matColumnDef="teacher">
         <th mat-header-cell *matHeaderCellDef> Teacher Name </th>
         <td mat-cell *matCellDef="let element"> {{element.teacher.name }} </td>e
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="studentName">
            <th mat-header-cell *matHeaderCellDef> Student Name </th>
            <td mat-cell *matCellDef="let element"> {{element.studentName}} </td>
        </ng-container>
        <ng-container matColumnDef="date" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let element"> {{element.date.toDate()|date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <!-- Weight Column -->


        <!-- Symbol Column -->
        <ng-container matColumnDef="symbol">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="accent" matTooltip="View" permission="Report Card" [permissionTypes]="[PermissionType.VIEW]" (click)="logActivityAndNavigate('View', element.id)">
                <mat-icon>remove_red_eye</mat-icon>
              </button>

              <!-- Edit Button -->
              <button mat-icon-button color="primary" *ngIf="!isExternal" permission="Report Card" [permissionTypes]="[PermissionType.EDIT]" matTooltip="Edit" (click)="logActivityAndNavigate('Edit', element.id)">
                <mat-icon>edit</mat-icon>
              </button>
            <button mat-icon-button color="warn" matTooltip="Delete" *ngIf="!isExternal" permission="Report Card" [permissionTypes]="[PermissionType.ARCHIVE]" (click)="delete(element.id)" mat-tool > <mat-icon>delete</mat-icon> </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of users"></mat-paginator>
</div>
</div>
